var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Transfer',{attrs:{"data-source":_vm.getdataSource,"filter-option":_vm.filterOption,"render":(item) => item.title,"showSelectAll":_vm.showSelectAll,"selectedKeys":_vm.selectedKeys,"targetKeys":_vm.getTargetKeys,"showSearch":_vm.showSearch},on:{"change":_vm.handleChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }